export default __webpack_public_path__ + "static/media/026-calligraphy.fde9d66c.svg";